export default __webpack_public_path__ + "static/media/kestrel11.c9496141.jpg";